import resize from '../resize';
import Swiper, { Navigation, Lazy } from 'swiper';
Swiper.use([Navigation, Lazy]);

const initWorthSlider = () => {
  const slider = document.querySelector('.worth-slider'),
    withoutSlider = document.querySelector('[data-worth-foreigntradebonus]');

  let swiper = null;

  function init() {
    if (!swiper) {
      swiper = new Swiper(slider, {
        lazy: true,
        autoHeight: false,
        loop: true,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          400: {
            slidesPerView: 1.5,
          },
          0: {
            slidesPerView: 1,
          },
        },
        navigation: {
          nextEl: '.worth .slider-navigation__button--next',
          prevEl: '.worth .slider-navigation__button--prev',
          disabledClass: 'last',
        },
        pagination: {
          el: '.worth .swiper-pagination',
          type: 'fraction',
        },
      });
    }
  }

  if (withoutSlider) {
    slider && resizeSwiper();
    slider && resize(resizeSwiper);
  } else {
    init();
  }

  function destroy() {
    if (swiper) {
      swiper.destroy();
      swiper = null;
    }
  }

  function resizeSwiper() {
    window.innerWidth < 768 ? init() : destroy();
  }
};

export default initWorthSlider;
